import mapKeys from "lodash.mapkeys";
import pickBy from "lodash.pickby";
import pick from "lodash.pick";
import { saveAs } from "file-saver";
import { unparse } from "papaparse";
import api_requests from "@/store/api/api_requests";
export const isType = (value, type) => typeof value === type;
export default {
    name: "Export",
    props: {
        data: {
            type: Array,
            required: true
        },
        fields: {
            required: false
        },
        name: {
            type: String,
            default: "data.csv"
        },
        delimiter: {
            type: String,
            default: ",",
            required: false
        },
        separatorExcel: {
            type: Boolean,
            default: false
        },
        encoding: {
            type: String,
            default: "utf-8"
        },
        advancedOptions: {
            type: Object,
            default: () => {}
        },
        labels: {
            required: false
        },
        testing: {
            required: false,
            default: false
        },
        isLoading: {
            required: false,
            default: false
        }
    },
    computed: {
        // unique identifier
        idName() {
            const now = new Date().getTime();
            return "export_" + now;
        },
        exportableData() {
            const filteredData = this.cleaningData();
            if (!filteredData.length) {
                return null;
            }
            return filteredData;
        }
    },
    methods: {
        labelsFunctionGenerator() {
            if (
                !isType(this.labels, "undefined") &&
                !isType(this.labels, "function") &&
                !isType(this.labels, "object")
            ) {
                throw new Error("Labels needs to be a function(value,key) or object.");
            }
            if (isType(this.labels, "function")) {
                return item => {
                    let _mapKeys = mapKeys(item, this.labels);
                    return _mapKeys;
                };
            }
            if (isType(this.labels, "object")) {
                return item => {
                    return mapKeys(item, (item, key) => {
                        return this.labels[key] || key;
                    });
                };
            }
            return item => item;
        },
        fieldsFunctionGenerator() {
            if (
                !isType(this.fields, "undefined") &&
                !isType(this.fields, "function") &&
                !isType(this.fields, "object") &&
                !Array.isArray(this.fields)
            ) {
                throw new Error("Fields needs to be a function(value,key) or array.");
            }
            if (
                isType(this.fields, "function") ||
                (isType(this.fields, "object") && !Array.isArray(this.fields))
            ) {
                return item => {
                    return pickBy(item, this.fields);
                };
            }
            if (Array.isArray(this.fields)) {
                return item => {
                    return pick(item, this.fields);
                };
            }
            return item => item;
        },
        cleaningData() {
            if (
                isType(this.fields, "undefined") &&
                isType(this.labels, "undefined")
            ) {
                return this.data;
            }
            const labels = this.labelsFunctionGenerator();
            const fields = this.fieldsFunctionGenerator();
            return this.data.map(item => labels(fields(item)));
        },
        generate() {
            let data = {};
            data.user = this.$store.getters.userInfo;
            data.content_id = this.$route.params.id;
            api_requests.send_event_export_users(data);
            this.$emit("export-started");
            const dataExport = this.exportableData;
            if (!dataExport) {
                console.error("No data to export");
                return;
            }
            let csv = unparse(
                dataExport,
                Object.assign(
                    {
                        delimiter: this.delimiter,
                        encoding: this.encoding
                    },
                    this.advancedOptions
                )
            );
            if (this.separatorExcel) {
                csv = "SEP=" + this.delimiter + "\r\n" + csv;
            }
            //Add BOM when UTF-8
            if (this.encoding === "utf-8") {
                csv = "\ufeff" + csv;
            }
            this.$emit("export-finished");
            if (!this.testing) {
                let blob = new Blob([csv], {
                    type: "application/csvcharset=" + this.encoding
                });
                saveAs(blob, this.name);
            }
        }
    }
};